interface ITrackSendMethod {
  (event: string, label: string, payload: Record<string, any>, callback?: CallableFunction): void;
}

class Track {
  private readonly send: ITrackSendMethod;

  constructor(send: ITrackSendMethod) {
    this.send = send;
  }

  public cardDomainLoaded = (callback?: CallableFunction): void => {
    this.send('ww_cardDomainLoaded', 'CardDomainLoaded', {}, callback);
  };

  public cardWasShown = (callback?: CallableFunction): void => {
    this.send('ww_cardWasShown', 'CardWasShown', {}, callback);
  };

  public hardCoverWasShown = (callback?: CallableFunction): void => {
    this.send('ww_hardCoverWasShown', 'HardCoverWasShown', {}, callback);
  };

  public hardCoverWasSwipedForward = (callback?: CallableFunction): void => {
    this.send('ww_hardCoverWasSwipedForward', 'HardCoverWasSwipedForward', {}, callback);
  };

  public hardCoverWasSwipedBack = (callback?: CallableFunction): void => {
    this.send('ww_hardCoverWasSwipedBack', 'HardCoverWasSwipedBack', {}, callback);
  };

  public hardCoverWasTappedForward = (callback?: CallableFunction): void => {
    this.send('ww_hardCoverWasTappedForward', 'HardCoverWasTappedForward', {}, callback);
  };

  public hardCoverWasTappedBack = (callback?: CallableFunction): void => {
    this.send('ww_hardCoverWasTappedBack', 'HardCoverWasTappedBack', {}, callback);
  };

  public firstPageWasShown = (callback?: CallableFunction): void => {
    this.send('ww_firstPageWasShown', 'FirstPageWasShown', {}, callback);
  };

  public firstPageWasSwipedForward = (callback?: CallableFunction): void => {
    this.send('ww_firstPageWasSwipedForward', 'FirstPageWasSwipedForward', {}, callback);
  };

  public firstPageWasSwipedBack = (callback?: CallableFunction): void => {
    this.send('ww_firstPageWasSwipedBack', 'FirstPageWasSwipedBack', {}, callback);
  };

  public firstPageWasTappedForward = (callback?: CallableFunction): void => {
    this.send('ww_firstPageWasTappedForward', 'FirstPageWasTappedForward', {}, callback);
  };

  public firstPageWasTappedBack = (callback?: CallableFunction): void => {
    this.send('ww_firstPageWasTappedBack', 'FirstPageWasTappedBack', {}, callback);
  };

  public secondPageWasShown = (callback?: CallableFunction): void => {
    this.send('ww_secondPageWasShown', 'SecondPageWasShown', {}, callback);
  };

  public secondPageWasSwipedForward = (callback?: CallableFunction): void => {
    this.send('ww_secondPageWasSwipedForward', 'SecondPageWasSwipedForward', {}, callback);
  };

  public secondPageWasSwipedBack = (callback?: CallableFunction): void => {
    this.send('ww_secondPageWasSwipedBack', 'SecondPageWasSwipedBack', {}, callback);
  };

  public secondPageWasTappedForward = (callback?: CallableFunction): void => {
    this.send('ww_secondPageWasTappedForward', 'SecondPageWasTappedForward', {}, callback);
  };

  public secondPageWasTappedBack = (callback?: CallableFunction): void => {
    this.send('ww_secondPageWasTappedBack', 'SecondPageWasTappedBack', {}, callback);
  };

  public giftCardPageRedeemResponseError = (callback?: CallableFunction): void => {
    this.send('ww_giftCardPageRedeemResponseError', 'GiftCardPageRedeemResponseError', {}, callback);
  };

  public giftCardPageWasShown = (callback?: CallableFunction): void => {
    this.send('ww_giftCardPageWasShown', 'GiftCardPageWasShown', {}, callback);
  };

  public giftCardPageRedeemWasTappedForward = (callback?: CallableFunction): void => {
    this.send('ww_giftCardPageRedeemWasTappedForward', 'GiftCardPageRedeemWasTappedForward', {}, callback);
  };

  public giftCardPageWasTappedForward = (callback?: CallableFunction): void => {
    this.send('ww_giftCardPageWasTappedForward', 'GiftCardPageWasTappedForward', {}, callback);
  };

  public giftCardPageWasTappedBack = (callback?: CallableFunction): void => {
    this.send('ww_giftCardPageWasTappedBack', 'GiftCardPageWasTappedBack', {}, callback);
  };

  public giftCardPageWasSwipedForward = (callback?: CallableFunction): void => {
    this.send('ww_giftCardPageWasSwipedForward', 'GiftCardPageWasSwipedForward', {}, callback);
  };

  public giftCardPageWasSwipedBack = (callback?: CallableFunction): void => {
    this.send('ww_giftCardPageWasSwipedBack', 'GiftCardPageWasSwipedBack', {}, callback);
  };

  public lastPageWasShown = (callback?: CallableFunction): void => {
    this.send('ww_lastPageWasShown', 'LastPageWasShown', {}, callback);
  };

  public lastPageWasSwipedBack = (callback?: CallableFunction): void => {
    this.send('ww_lastPageWasSwipedBack', 'LastPageWasSwipedBack', {}, callback);
  };

  public lastPageWasTappedBack = (callback?: CallableFunction): void => {
    this.send('ww_lastPageWasTappedBack', 'LastPageWasTappedBack', {}, callback);
  };

  public tappedWatchAgain = (callback?: CallableFunction): void => {
    this.send('ww_tappedWatchAgain', 'TappedWatchAgain', {}, callback);
  };

  public tappedRespondToCard = (callback?: CallableFunction): void => {
    this.send('ww_tappedRespondToCard', 'TappedRespondToCard', {}, callback);
  };

  public tappedRespondToCardSent = (callback?: CallableFunction): void => {
    this.send('ww_tappedRespondToCardSent', 'TappedRespondToCardSent', {}, callback);
  };

  public tappedGetCardSnacks = (callback?: CallableFunction): void => {
    this.send('ww_getCardSnacksTapped', 'GetCardSnacksTapped', {}, callback);
  };

  public tappedCreateYourOwn = (callback?: CallableFunction): void => {
    this.send('ww_downloadAppButtonTapped', 'DownloadAppButtonTapped', {}, callback);
  };

  public tappedShare = (platformName: string, callback?: CallableFunction): void => {
    this.send('ww_tappedShare', 'TappedShare', { platformName }, callback);
  };

  public tappedHamburgerMenu = (callback?: CallableFunction): void => {
    this.send('ww_tappedHamburgerMenu', 'TappedHamburgerMenu', {}, callback);
  };

  public tappedHamburgerVisitWebsite = (callback?: CallableFunction): void => {
    this.send('ww_tappedHamburgerVisitWebsite', 'TappedHamburgerVisitWebsite', {}, callback);
  };

  public tappedHamburgerTermsAndConditions = (callback?: CallableFunction): void => {
    this.send('ww_tappedHamburgerTermsAndConditions', 'TappedHamburgerTermsAndConditions', {}, callback);
  };

  public tappedHamburgerDownloadApp = (callback?: CallableFunction): void => {
    this.send('ww_tappedHamburgerDownloadApp', 'TappedHamburgerDownloadApp', {}, callback);
  };

  public tappedFacebookFollow = (callback?: CallableFunction): void => {
    this.send('ww_tappedFacebookFollow', 'TappedFacebookFollow', {}, callback);
  };

  public tappedInstagramFollow = (callback?: CallableFunction): void => {
    this.send('ww_tappedInstagramFollow', 'TappedInstagramFollow', {}, callback);
  };

  public tappedTwitterFollow = (callback?: CallableFunction): void => {
    this.send('ww_tappedTwitterFollow', 'TappedTwitterFollow', {}, callback);
  };

  public tappedSendReply = (callback?: CallableFunction): void => {
    this.send('ww_tappedSendReply', 'TappedSendReply', {}, callback);
  };

  public tappedSkipReply = (callback?: CallableFunction): void => {
    this.send('ww_tappedSkipReply', 'TappedSkipReply', {}, callback);
  };

  public tappedAcceptPromoTSO = (callback?: CallableFunction): void => {
    this.send('ww_tappedPromoTSO', 'TappedAcceptPromoTSO', {}, callback);
  };

  public tappedSkipPromoTSO = (callback?: CallableFunction): void => {
    this.send('ww_tappedPromoTSO', 'TappedSkipPromoTSO', {}, callback);
  };

  public tappedAcceptBirthdayReminder = (callback?: CallableFunction): void => {
    this.send('ww_tappedAcceptBirthdayReminder', 'TappedAcceptBirthdayReminder', {}, callback);
  };

  public tappedAcceptHolidayReminder = (callback?: CallableFunction): void => {
    this.send('ww_tappedAcceptHolidayReminder', 'TappedAcceptHolidayReminder', {}, callback);
  };

  public tappedSkipBirthdayReminder = (callback?: CallableFunction): void => {
    this.send('ww_tappedSkipBirthdayReminder', 'TappedSkipBirthdayReminder', {}, callback);
  };

  public tappedSkipHolidayReminder = (callback?: CallableFunction): void => {
    this.send('ww_tappedSkipHolidayReminder', 'TappedSkipHolidayReminder', {}, callback);
  };

  public tappedGetEarlyAccess = (callback?: CallableFunction): void => {
    this.send('ww_tappedGetEarlyAccess', 'TappedGetEarlyAccess', {}, callback);
  };

  public tappedGetApp = (callback?: CallableFunction): void => {
    this.send('ww_tappedGetApp', 'TappedGetApp', {}, callback);
  };

  public useGiftButtonTapped = (callback?: CallableFunction): void => {
    this.send('ww_useGiftButtonTapped', 'UseGiftButtonTapped', {}, callback);
  };

  public useGiftMethodTriggered = (callback?: CallableFunction): void => {
    this.send('ww_useGiftMethodTriggered', 'UseGiftMethodTriggered', {}, callback);
  };

  public useGiftMethodNoGiftCard = (callback?: CallableFunction): void => {
    this.send('ww_useGiftMethodNoGiftCard', 'UseGiftMethodNoGiftCard', {}, callback);
  };

  public useGiftMethodShortLinkAlreadyExists = (callback?: CallableFunction): void => {
    this.send('ww_useGiftMethodShortlinkAlreadyExists', 'UseGiftMethodShortlinkAlreadyExists', {}, callback);
  };

  public useGiftMethodShortLinkDoesntExist = (callback?: CallableFunction): void => {
    this.send('ww_useGiftMethodShortlinkDoesntExist', 'UseGiftMethodShortlinkDoesntExist', {}, callback);
  };

  public skipPromo = (callback?: CallableFunction): void => {};

  public skipDownload = (callback?: CallableFunction): void => {};

  public errorRequestData = (tryNumber: number, error: string, callback?: CallableFunction): void => {
    this.send('ww_loadDataError', 'LoadDataError', { tryNumber, error }, callback);
  };
}

export default Track;
